// Bileli · app/store — the CONTEXT TYPE VOCABULARY, split from bileliContext.store.ts so the router
// (routes.ts / navStack.ts) and its unit tests can import kinds/types WITHOUT pulling Telegram's
// global machinery (the store imports getGlobal/setGlobal; this module is pure).

// 'spaces' = the teacher «Пространства» drain screen; 'profile' = the account page (BI-MODAL — reachable
// from both Учёба and Препод without flipping the mode, like the lesson kind); 'students' = the teacher
// analytics home (overview KPIs + courses), drilling into 'roster' (per-course student table) and
// 'student' (per-student 360°); 'team' = the «Команда» school-management page (staff + invites + org
// settings — moved OFF the profile page 2026-07-15 for findability).
// Runtime list + derived type (was a bare union) — the router's parentOf/seeding and the routes
// round-trip tests iterate it, so a new home kind can't silently miss its URL wiring again.
export const BILELI_HOME_KINDS = [
  'dashboard', 'catalog', 'my-learning', 'teacher-courses', 'spaces',
  'profile', 'students', 'practice', 'teacher-programs', 'earnings', 'my-orders', 'team',
] as const;
export type BileliHomeKind = typeof BILELI_HOME_KINDS[number];

export type BileliContextKind = BileliHomeKind | 'course' | 'lesson' | 'editor' | 'module' | 'roster'
  | 'student' | 'live' | 'program' | 'provider' | 'program-editor';

export function isHomeKind(kind: BileliContextKind): kind is BileliHomeKind {
  return (BILELI_HOME_KINDS as readonly string[]).includes(kind);
}

export interface BileliContext {
  kind: BileliContextKind;
  courseId?: string;
  lessonId?: string;
  moduleId?: string;
  cohortId?: string; // students drill-in: which cohort's roster/student
  studentId?: string; // students drill-in: the per-student 360° page
  programSlug?: string; // programs (PR #184): public program page / teacher program editor
  orgSlug?: string; // provider (org) public profile page
  isDraft?: boolean; // module workspace: the "add lesson" screen
  // Quiz "rewatch" deep-link: open the video positioned at this second. EPHEMERAL — deliberately not
  // encoded in the URL hash (routes.ts fromContext ignores it), so history records stay byte-identical
  // and a reload simply drops it.
  startTimeSec?: number;
}
